import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    Box
} from '@mui/material';
import * as actions from '../redux.actions';
import * as selectors from '../redux.selectors';

const TemplateDialog = () => {
    const dispatch = useDispatch();
    const dialog = useSelector(selectors.selectTemplateDialog);
    const loading = useSelector(selectors.selectLoading);

    const [formData, setFormData] = useState({
        name: '',
        description: ''
    });

    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (dialog.open && dialog.data) {
            setFormData({
                name: dialog.data.name || '',
                description: dialog.data.description || ''
            });
        } else if (!dialog.open) {
            setFormData({ name: '', description: '' });
            setErrors({});
        }
    }, [dialog.open, dialog.data]);

    const handleChange = (field) => (event) => {
        setFormData(prev => ({
            ...prev,
            [field]: event.target.value
        }));
        if (errors[field]) {
            setErrors(prev => ({ ...prev, [field]: '' }));
        }
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.name.trim()) {
            newErrors.name = 'Template name is required';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = () => {
        if (!validate()) return;

        if (dialog.data) {
            dispatch(actions.updateTemplate(dialog.data.id, formData));
        } else {
            dispatch(actions.createTemplate(formData));
        }
    };

    const handleClose = () => {
        dispatch(actions.closeTemplateDialog());
    };

    return (
        <Dialog
            open={dialog.open}
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle>
                {dialog.data ? 'Edit Template' : 'Create Template'}
            </DialogTitle>
            <DialogContent dividers sx={{ maxHeight: '60vh', overflowY: 'auto' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 2 }}>
                    <TextField
                        label="Template Name"
                        value={formData.name}
                        onChange={handleChange('name')}
                        error={!!errors.name}
                        helperText={errors.name}
                        required
                        fullWidth
                        size="small"
                    />
                    <TextField
                        label="Description"
                        value={formData.description}
                        onChange={handleChange('description')}
                        multiline
                        rows={4}
                        fullWidth
                        size="small"
                    />
                </Box>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button onClick={handleClose} sx={{ textTransform: 'none' }} size="small">
                    Cancel
                </Button>
                <Button
                    onClick={handleSubmit}
                    variant="contained"
                    disabled={loading}
                    sx={{ textTransform: 'none' }}
                    size="small"
                >
                    {dialog.data ? 'Update' : 'Create'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default TemplateDialog;
